import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/error-icon.png'
import _imports_1 from '@/assets/images/star.png'
import _imports_2 from '@/assets/images/standard.png'
import _imports_3 from '@/assets/images/standard2.png'
import _imports_4 from '@assets/images/star.png'
import _imports_5 from '@assets/images/standard.png'


const _hoisted_1 = { class: "grade-settlement-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "new-grad-container"
}
const _hoisted_3 = { class: "grad-inner" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "grad-body" }
const _hoisted_6 = { class: "grad-time-box" }
const _hoisted_7 = { class: "time-left-group" }
const _hoisted_8 = { class: "time-box-container info-btn" }
const _hoisted_9 = { class: "inner-box" }
const _hoisted_10 = { class: "time-text font-DIN" }
const _hoisted_11 = { class: "time-box-container info-btn" }
const _hoisted_12 = { class: "time-text" }
const _hoisted_13 = {
  key: 0,
  class: "time-box-container info-btn"
}
const _hoisted_14 = { class: "warn-row" }
const _hoisted_15 = { class: "main-content-row" }
const _hoisted_16 = { class: "left-column" }
const _hoisted_17 = { class: "score-eval-row" }
const _hoisted_18 = { class: "info-btn score-card flex-row" }
const _hoisted_19 = { class: "vl-txt font-DIN" }
const _hoisted_20 = { class: "info-btn score-card flex-row" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "deviation-row flyDeviationInfo-container" }
const _hoisted_23 = { class: "right-column" }
const _hoisted_24 = { class: "info-btn eval-card flex-row" }
const _hoisted_25 = { class: "summary-card info-btn" }
const _hoisted_26 = { class: "summary-content" }
const _hoisted_27 = { class: "summary-text" }
const _hoisted_28 = { class: "summary-card info-btn" }
const _hoisted_29 = { class: "summary-content" }
const _hoisted_30 = { class: "suggest-text" }
const _hoisted_31 = {
  key: 1,
  class: "grad-container"
}
const _hoisted_32 = { class: "grad-inner" }
const _hoisted_33 = { class: "title" }
const _hoisted_34 = { class: "grad-body" }
const _hoisted_35 = { class: "grad-time-box" }
const _hoisted_36 = { class: "time-box-container info-btn flex-row" }
const _hoisted_37 = { class: "inner-box" }
const _hoisted_38 = { class: "time-text font-DIN" }
const _hoisted_39 = { class: "warn-box" }
const _hoisted_40 = { class: "score-container" }
const _hoisted_41 = { class: "lf-box" }
const _hoisted_42 = { class: "lft-tp-box info-btn flex-row" }
const _hoisted_43 = { class: "vl-txt font-DIN" }
const _hoisted_44 = { class: "lft-bt-box info-btn flex-row" }
const _hoisted_45 = { class: "rgt-box info-btn" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "grad-base-info flyDeviationInfo-container" }

import { ref, reactive, onBeforeMount, onBeforeUnmount, nextTick } from 'vue'
import { getSimulatorTrainingDetail, getTrainingAiDataById,getStationSceneDataByStationId } from '@/service'
import { $enum,$config } from '@/global'
import useFlightEchartOptions from '@/hooks/useFlightEchartOptions'
import { useStore } from 'vuex'

export default /*@__PURE__*/_defineComponent({
  __name: 'GradeSettlement',
  props: {
  forbidAiCoach: {
    type: Number,
    default: 0
  },
  id: {
    type: String,
    required: true
  },
  crash: {
    type: Boolean,
    default: false
  },
  sceneTypeId: {
    type: [String, Number],
    default: ''
  },
  replayTitle: {
    type: String,
    default: ''
  }
},
  emits: ['onClose'],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore()
const props = __props

const emit = __emit

const gradCanvasRef = ref<HTMLDivElement | null>(null)

const { initEcharts, updateRadarData, resizeEcharts } = useFlightEchartOptions()

// 窗口大小变化时重绘雷达图
const handleResize = () => {
  if (props.forbidAiCoach === 1) {
    resizeEcharts()
  }
}

const state = reactive({
  data: {
    overallTime: '',
    overallScore: '',
    isPass: true,
    pictureUrl: '',
  } as any,
  gradInfo: {} as any,
  flyDeviationViewMode:$enum.FlyDeviationViewMode.曲线,
  aiData: null as any, // AI评价数据
  replayPageMode:props.sceneTypeId == $enum.SceneCategoryEnum.科目训练 ? 1 : 2,
  radar: null as any,
  windDirection:null as any,
  windSpeed:null as any,
  sceneId:null as any,
  stationId:null as any,
})

// 获取训练详情数据
async function onGetSimulatorTrainingDetail() {
  const { code, data } = (await getSimulatorTrainingDetail({ id: props.id })) as any
  if (code === $enum.EnumResult.SUCCESS) {
    state.data = data
    state.gradInfo = {}
    state.windDirection = data?.windDirection
    state.windSpeed = data?.windPower
    state.sceneId = data?.sceneId
    state.stationId = data?.stationId
    store.commit('viewData/setFlyReplayData', {
      ...store.state.viewData.flyReplayData,
      uavNestId: data?.uavNestId,
      uavSpecificationId: data?.uavSpecificationId,
      enterPageMode: 2,
    })
    data?.itemList?.forEach((item: any) => {
      if (item.typeName === '高度偏差') {
        state.gradInfo.height = { ...updateFlyingInfo(item), unit: 'm' }
      } else if (item.typeName === '位置偏差') {
        state.gradInfo.position = { ...updateFlyingInfo(item), unit: 'm' }
      } else if (item.typeName === '用时偏差' || item.typeName === '目标时间') {
        if (!state.gradInfo.timeDeviation) {
          state.gradInfo.timeDeviation = []
        }
        state.gradInfo.timeDeviation = [...state.gradInfo.timeDeviation, { ...updateFlyingInfo(item), unit: 's' }]
      } else if (item.typeName === '夹角偏差') {
        state.gradInfo.headAngle = { ...updateFlyingInfo(item), unit: '°' }
      } else if (item.typeName === '角速度偏差') {
        state.gradInfo.angle = { ...updateFlyingInfo(item), unit: '°/s' }
      } else if (item.typeName === '速度偏差') {
        state.gradInfo.speed = { ...updateFlyingInfo(item), unit: 'm/s' }
      }
    })
    state.gradInfo = sortObjectByKeys(state.gradInfo)
  }
}

// 获取AI评价数据
async function onGetTrainingAiDataById() {
  if (props.forbidAiCoach != 1) return
  const { code, data } = (await getTrainingAiDataById({ id: props.id })) as any
  if (code === $enum.EnumResult.SUCCESS) {
    state.aiData = data
    // 初始化雷达图
    await nextTick()
    initEcharts()
    // 更新雷达图数据（转换字段名：驼峰 -> 下划线）
    if (data?.radar) {
      const radarData = {
        flight_stability: data.flightStability,
        deviation_control: data.deviationControl,
        error_correction: data.errorCorrection,
        anti_disturbance: data.antiDisturbance,
        stick_proficiency: data.stickProficiency
      }
      state.radar = radarData
      updateRadarData(radarData)
    }
  }
}

// 处理飞行信息数据
function updateFlyingInfo(data: any) {
  let max = Number(data?.maxPassingValue || 0)
  let min = Number(data?.minPassingValue || 0)
  if (data?.itemValue > max && data?.itemValue < max + 0.01) {
    data.itemValue = max + 0.01
  }
  let value = Number(data?.itemValue || 0)
  let lowerValue = Number(data?.minItemValue || 0)
  let higherValue = Number(data?.maxItemValue || 0)
  let range = max - min
  let leftValue = Math.max(min, lowerValue)
  let rightValue = Math.min(max, higherValue)
  let progress = Math.min(1, (rightValue - leftValue) / range) * 100
  let color = lowerValue < min || higherValue > max ? '#E70102' : '#2174FF'
  let left = (leftValue - min) / range * 100

  if (data.typeName === '夹角偏差') {
    lowerValue = lowerValue.toFixed(1) as any
    higherValue = higherValue.toFixed(1) as any
  } else if (data.typeName === '用时偏差' || data.typeName === '目标时间') {
    lowerValue = lowerValue.toFixed(0) as any
    higherValue = higherValue.toFixed(0) as any
    value = value.toFixed(0) as any
  } else {
    lowerValue = lowerValue.toFixed(2) as any
    higherValue = higherValue.toFixed(2) as any
  }
  return { value, progress, max, min, name: data.typeName, lowerValue, higherValue, color, left, pictureUrl: data.pictureUrl ? $config.FILE_ROOT_PATH + data.pictureUrl : undefined }
}

// 格式化时间
function formatFlexibleTime(timeStr: string) {
  const totalSeconds = Number(timeStr)
  if (isNaN(totalSeconds)) return '00:00'

  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = Math.floor(totalSeconds % 60)

  if (hours === 0 && minutes === 0 && seconds === 0) {
    return '00:00'
  } else if (hours === 0 && minutes === 0) {
    return `00:${String(seconds).padStart(2, '0')}`
  } else if (hours === 0) {
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
  } else {
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
  }
}

// 按键排序对象
function sortObjectByKeys(obj: any) {
  const order = ['height', 'position', 'timeDeviation', 'headAngle', 'angle', 'speed']
  const newObj: any = {}
  order.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = obj[key]
    }
  })
  Object.keys(obj).forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(newObj, key)) {
      newObj[key] = obj[key]
    }
  })
  return newObj
}

const handleFlyReplayClick = async () => {
  window?.playClick()
  const { code, data } = (await getStationSceneDataByStationId({ stationId: state.stationId })) as any
  if (code === $enum.EnumResult.SUCCESS && data && Object.keys(data).length) {
    store.commit("persistence/setStationId", state.stationId);
    const deviationInfo = Object.keys(state.gradInfo).filter(key => key !== 'timeDeviation').reduce((obj: any, key) => {obj[key] = state.gradInfo[key].name;return obj;}, {})
    store.commit('viewData/setFlyReplayData', {
      ...store.state.viewData.flyReplayData,
      title: props.replayTitle,
      score: state.data?.overallScore,
      isPass: state.data?.isPass,
      rating: state.aiData?.rating,
      abilityData: state?.radar,
      flightSummary: state.aiData?.flightConclusion,
      trainingSuggestion: state.aiData?.trainingSuggestion,
      windDirection: state.windDirection,
      windSpeed: state.windSpeed,
      pageMode: state.replayPageMode,
      enterMode: 2,
      trainingId: props.id,
      deviationInfo,
      scenePictureUrl: data.scenePictureUrl,
    })
    store.commit('viewData/setShowFlyReplay', true)
  }
}

// 获取数据供外部使用
const getGradInfo = () => state.gradInfo
const getGradData = () => state.data

__expose({
  gradCanvasRef,
  getGradInfo,
  getGradData,
  state
})

onBeforeMount(()=>{
  onGetSimulatorTrainingDetail()
  onGetTrainingAiDataById()
  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
})

return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_vkm_flyDeviationInfo = _resolveComponent("vkm-flyDeviationInfo")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.forbidAiCoach === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "成绩", -1)),
              _createVNode(_component_vkm_svg, {
                "icon-name": "close_icon",
                class: "icon",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onClose')))
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_scrollbar, {
                class: "grad-scrollbar",
                "wrap-class": "grad-scrollbar-wrap"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_vkm_svg, {
                            "icon-name": "clock",
                            class: "icon"
                          }),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(formatFlexibleTime(state.data?.overallTime)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", {
                          class: "inner-box",
                          onClick: _cache[1] || (_cache[1] = ()=>{state.flyDeviationViewMode = state.flyDeviationViewMode === _unref($enum).FlyDeviationViewMode.卡片 ? _unref($enum).FlyDeviationViewMode.曲线 : _unref($enum).FlyDeviationViewMode.卡片})
                        }, [
                          _createVNode(_component_vkm_svg, {
                            "icon-name": "vk_qh_line",
                            class: "icon"
                          }),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(state.flyDeviationViewMode == _unref($enum).FlyDeviationViewMode.卡片 ? '曲线' : '卡片'), 1)
                        ])
                      ]),
                      (state.stationId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", {
                              class: "inner-box",
                              onClick: handleFlyReplayClick
                            }, [
                              _createVNode(_component_vkm_svg, {
                                "icon-name": "vk_hf_line",
                                class: "icon"
                              }),
                              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "time-text" }, "飞行回放", -1))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_14, _cache[5] || (_cache[5] = [
                      _createElementVNode("div", { class: "warn-box" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: ""
                        }),
                        _createElementVNode("p", null, "飞机已坠毁，请谨慎飞行，成绩为0分")
                      ], -1)
                    ]), 512), [
                      [_vShow, __props.crash]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "img-box flex-row" }, [
                            _createElementVNode("div", { class: "icon-wrapper star-icon" }, [
                              _createElementVNode("img", {
                                src: _imports_1,
                                alt: ""
                              })
                            ]),
                            _createElementVNode("span", null, "得分")
                          ], -1)),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(state.data?.overallScore), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "img-box flex-row" }, [
                            _createElementVNode("div", { class: "icon-wrapper check-icon" }, [
                              _createElementVNode("img", {
                                src: _imports_2,
                                alt: ""
                              })
                            ]),
                            _createElementVNode("span", null, "成绩")
                          ], -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(state.data?.isPass ? 'green' : 'red')
                          }, _toDisplayString(state.data?.isPass ? '合格' : '不合格'), 3)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "radar-box info-btn",
                        ref_key: "gradCanvasRef",
                        ref: gradCanvasRef
                      }, [
                        _createElementVNode("img", {
                          src: _unref($config).FILE_ROOT_PATH + state.data?.pictureUrl,
                          alt: ""
                        }, null, 8, _hoisted_21)
                      ], 512),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_vkm_flyDeviationInfo, {
                          isShowFlightInfo: false,
                          isReady: true,
                          flyingInfo: state.gradInfo,
                          viewMode: state.flyDeviationViewMode,
                          useStaticImage: true
                        }, null, 8, ["flyingInfo", "viewMode"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "img-box flex-row" }, [
                          _createElementVNode("div", { class: "icon-wrapper thumb-icon" }, [
                            _createElementVNode("img", {
                              src: _imports_3,
                              alt: ""
                            })
                          ]),
                          _createElementVNode("span", null, "AI飞行评价")
                        ], -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['eval-text', state.aiData?.rating === '优秀' ? 'green' : state.aiData?.rating === '良好' ? 'yellow' : 'red'])
                        }, _toDisplayString(state.aiData?.rating || '暂无评价'), 3)
                      ]),
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "ability-radar-box info-btn" }, [
                        _createElementVNode("div", { id: "echartBox" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_25, [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "summary-header" }, [
                          _createElementVNode("span", { class: "summary-title" }, "飞行总结")
                        ], -1)),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_el_tooltip, {
                            class: "box-item",
                            effect: "dark",
                            content: state.aiData?.flightConclusion || '暂无总结',
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_27, _toDisplayString(state.aiData?.flightConclusion || '暂无总结'), 1)
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "summary-header" }, [
                          _createElementVNode("span", { class: "summary-title" }, "AI教员训练建议")
                        ], -1)),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_el_tooltip, {
                            class: "box-item",
                            effect: "dark",
                            content: state.aiData?.trainingSuggestion || '暂无建议',
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_30, _toDisplayString(state.aiData?.trainingSuggestion || '暂无建议'), 1)
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.forbidAiCoach === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _cache[12] || (_cache[12] = _createElementVNode("span", null, "成绩", -1)),
              _createVNode(_component_vkm_svg, {
                "icon-name": "close_icon",
                class: "icon",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('onClose')))
              })
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_vkm_svg, {
                      "icon-name": "clock",
                      class: "icon"
                    }),
                    _createElementVNode("span", _hoisted_38, _toDisplayString(formatFlexibleTime(state.data?.overallTime)), 1)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_39, _cache[13] || (_cache[13] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1),
                  _createElementVNode("p", null, "飞机已坠毁，请谨慎飞行，成绩为0分", -1)
                ]), 512), [
                  [_vShow, __props.crash]
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "img-box flex-row" }, [
                      _createElementVNode("img", { src: _imports_4 }),
                      _createElementVNode("span", null, "得分")
                    ], -1)),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(state.data?.overallScore), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "img-box flex-row" }, [
                      _createElementVNode("img", { src: _imports_5 }),
                      _createElementVNode("span", null, "评价")
                    ], -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(state.data?.isPass ? 'vl-txt green' : 'vl-txt red')
                    }, _toDisplayString(state.data?.isPass ? '合格' : '不合格'), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("img", {
                    src: _unref($config).FILE_ROOT_PATH + state.data?.pictureUrl,
                    alt: ""
                  }, null, 8, _hoisted_46)
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_vkm_flyDeviationInfo, {
                  isShowFlightInfo: false,
                  isReady: true,
                  flyingInfo: state.gradInfo,
                  viewMode: 'card',
                  useStaticImage: true
                }, null, 8, ["flyingInfo"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})